export enum NodeSelectedState {
    checked,
    unChecked,
    indeterminate
}
